/**
 * The short list of topics offered in the support chat.
 *
 * Kept apart from the full approved knowledge base so the chat bubble, which
 * appears on every page, doesn't pull the whole help library into the initial
 * page download.
 */
export const SUPPORT_TOPIC_OPTIONS = [
  "Membership & Billing",
  "Login / Access",
  "Workshops & Events",
  "Journals & Exercises",
  "Using the Platform",
  "Technical Problem",
  "Cancellation",
  "Something Else",
] as const;

export type SupportTopicOption = (typeof SUPPORT_TOPIC_OPTIONS)[number];
